<template>
  <div
    style="width: 100%"
    :class="{ 'inventory-table-theme': isInventoryRoute, 'content-fit-table': fitContent }"
  >
    <order-record-layout v-if="orderCards" v-loading="loading">
      <table class="order_table order-list-table" border="0" cellspacing="0" cellpadding="0">
        <thead><tr class="order-list-header-row">
          <th v-for="(item, index) in tableList" :key="index"
            :align="columnAlign(item)"
            :class="columnLabelClassName(item)">{{ item.label }}</th>
        </tr></thead>
        <tbody v-if="!list.length"><tr><td :colspan="Math.max(1, tableList.length)">暂无数据</td></tr></tbody>
        <tbody v-for="(row, rowIndex) in list" :key="rowKey ? row[rowKey] : rowIndex">
          <tr>
            <td v-for="(item, index) in tableList" :key="index"
              :align="columnAlign(item)"
              :class="columnClassName(item)">
              <div style="margin:0 2px"
                :class="{ 'base-table-cell-nowrap': shouldNoWrap(displayCellValue({ row, $index: rowIndex }, item), item), 'inventory-row-actions': isInventoryActionRoute && isOperationColumn(item) }"
                :title="cellTitle(displayCellValue({ row, $index: rowIndex }, item), item)"
              ><template v-if="isSequenceColumn(item)">{{ displayCellValue({ row, $index: rowIndex }, item) }}</template><slot v-else :name="item.prop" :row="row" :index="rowIndex">
                {{
                  displayCellValue({ row, $index: rowIndex }, item)
                    ? displayCellValue({ row, $index: rowIndex }, item)
                    : item.label
                    ? (item.default || "-")
                    : ""
                }}
              </slot></div>
            </td>
          </tr>
        </tbody>
      </table>
    </order-record-layout>
    <el-table v-else
      @selection-change="handleSelectionChange"
      @current-change="handleCurrentChange"
      v-loading="loading"
      :tree-props="treeProps ? treeProps : ''"
      :row-key="rowKey"
      :data="list"
      style="width: 100%" 
      :height="height"
      ref="multipleTable"
      :span-method="objectSpanMethod"
	  :size="sizeSmall"  
    >
      <el-table-column
        v-if="selection"
        type="selection" 
        :width="selectionWidth"
        :selectable="selectable"
      >
      </el-table-column>
      <!-- 自定义单选列 -->
      <el-table-column :width="selectionWidth" align="center" label="选择" v-if="!multiply">
        <template slot-scope="scope">
          <el-radio
            :label="scope.$index"
            v-model="selectedRow"
            @change="selectRow(scope.row)"
          ></el-radio>
        </template>
      </el-table-column>
      <el-table-column
        v-for="(item, index) in tableList"
        :key="index"
        v-bind="item"
        :align="columnAlign(item)"
        :width="columnWidth(item)"
        :min-width="fitContent ? undefined : columnMinWidth(item)"
        :fixed="fitContent && isOperationColumn(item) ? 'right' : (item.fixed || false)"
        :class-name="columnClassName(item)"
        :label-class-name="columnLabelClassName(item)"
      >
        <template #default="scope">
          <div
            style="margin:0 2px"
            :class="{ 'base-table-cell-nowrap': shouldNoWrap(displayCellValue(scope, item), item), 'inventory-row-actions': isInventoryActionRoute && isOperationColumn(item) }"
            :title="cellTitle(displayCellValue(scope, item), item)"
          ><template v-if="isSequenceColumn(item)">{{ displayCellValue(scope, item) }}</template><slot v-else :name="item.prop" :row="scope.row" :index="scope.$index">
            {{
              displayCellValue(scope, item)
                ? displayCellValue(scope, item)
                : item.label
                ? (item.default || "-")
                : ""
            }}
          </slot></div>
        </template>
      </el-table-column>
    </el-table>
	 <slot name="footerPage"></slot>
    <div class="pageclass"
      v-if="total > pagesize"
      :style="{ textAlign: pageAlign, padding: pagePadding }"
    >
      <!-- <el-pagination
        background
        :hide-on-single-page="true"
        @current-change="changepage"
        :current-page="page"
        :page-size="pagesize"
        layout="total, prev, pager, next, jumper"
        :total="total"
      ></el-pagination> -->
	  <el-pagination
	    background  :small="sizeSmall=='mini'?true:false"
		:hide-on-single-page="true"
	    @size-change="handleSizeChange"
	    @current-change="changepage"
	    :current-page="page"
	    :page-size="pagesize"
		:page-sizes="pageSizeArr"
	    :layout="(sizesType?'sizes,':'')+'total, prev, pager, next, jumper'"
	    :total="total"
	  ></el-pagination>
    </div>
  </div>
</template>

<script>
// import { eltips } from '@/util/util.js';
const baseTableUtils = require("./baseTableUtils");
const { contentTableLayout } = require("./contentTableLayout");
const { resetTablePageScroll } = require("./tablePageScroll");

export default {
  name: "baseTable",
  mixins: [contentTableLayout],
  props: {
    // 仅盘点过的订单主表显式启用；普通业务表格继续使用原 Element 表格。
    orderCards: { type: Boolean, default: false },
    // 长单据按页更换明细后回到表头；默认关闭，保留其他列表的滚动行为。
    resetScrollOnPageChange: { type: Boolean, default: false },
    // 兼容已经显式启用 fitContent 的页面；新接入的普通表格默认保留列原对齐。
    preserveColumnAlign: { type: Boolean, default: false },
	  pageSizeArr:{
		  type:Array,
		  default:() =>[20,50,100, 200, 300, 400]
	  },
	  sizesType:{
		  type: Boolean,
		  default: false,
	  },
	  sizeSmall:{
		  type: String,
		  default: '',
	  },
    // 从父组件接收的方法
    objectSpanMethod: {
      type: Function,
      required: false,
    },
    treeProps: {
      type: Object,
      default: () => {
        return {
          children: "children",
          hasChildren: "hasChildren",
        };
      },
    },
    rowKey: {
      typeof: String,
      // default: "category_id",
      default: "",
    },
    selection: {
      type: Boolean,
      default: false,
    },
	selectable: {
	  type: Function,
	  default: () => true,
	},
	selectionWidth: {
	  type: [Number,String],
	  default: 50,
	},
    tableList: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
    list: {
      type: Array,
      default: () => [],
    },
    total: {
      type: Number,
      default: 0,
    },
	maxHeight: {
      type: [Number,String],
      default: 990,
    },
    page: {
      type: Number,
      default: 1,
    },
    pagesize: {
      type: Number,
      default: 10,
    },
    pageAlign: {
      type: String,
      default: "center",
    },
    pagePadding: {
      type: String,
      default: "20px 0",
    },
    multiply: {
      type: Boolean,
      default: true,
    },
    height:{
      type:Number
    }
  },
  data() {
    return {
      selectedRow: null, // 存储选中行的索引
      currentSelected: null, // 存储选中行的数据
    };
  },
  watch: {
    page() {
      if (this.resetScrollOnPageChange) this.$nextTick(() => resetTablePageScroll(this.$el));
    },
  },
  computed: {
    isInventoryRoute() {
      const path = this.$route && this.$route.path ? this.$route.path : "";
      return /^\/weishop\/application\/inventory(?:\/|$)/.test(path);
    },
    isInventoryActionRoute() {
      const path = this.$route && this.$route.path ? this.$route.path : "";
      return /^\/weishop\/(?:shop\/)?application\/inventory(?:\/|$)/.test(path);
    },
  },
  created() {},
  methods: {
    isSequenceColumn: baseTableUtils.isSequenceColumn,
    isOperationColumn: baseTableUtils.isOperationColumn,
    displayCellValue(scope, item) {
      return baseTableUtils.displayCellValue(scope.row, item, scope.$index, this.page, this.pagesize);
    },
    columnWidth(item) {
      if (this.fitContent) return this.contentWidths[this.tableList.indexOf(item)] || 120;
      return baseTableUtils.sequenceColumnWidth(item, this.list);
    },
    columnAlign(item) {
      const supplied = this.$options.propsData || {};
      const explicitContentFit = Object.prototype.hasOwnProperty.call(supplied, 'fitContent') ||
        Object.prototype.hasOwnProperty.call(supplied, 'fit-content');
      return this.fitContent && explicitContentFit && !this.preserveColumnAlign ? 'center' : (item.align || 'center');
    },
    cellTitle: baseTableUtils.cellTitle,
    columnClassName: baseTableUtils.columnClassName,
    columnLabelClassName: baseTableUtils.columnLabelClassName,
    columnMinWidth: baseTableUtils.columnMinWidth,
    shouldNoWrap: baseTableUtils.shouldNoWrap,
	  handleSizeChange(e){
		console.log(e) 
		 this.$emit("changeSize", e);
	  },
    changepage(e) {
      this.$emit("changePage", e);
    },
    handleSelectionChange(e) {
      if (this.selection) {
        this.$emit("tableSelectionChange", e);
      }
    },
    // 单选处理函数
    selectRow(row) {
      this.currentSelected = row;
      // 手动设置高亮行
      this.$refs.multipleTable.setCurrentRow(row);
    },

    // 高亮行变化时的回调
    handleCurrentChange(currentRow) {
      if (currentRow) {
        this.selectedRow = this.list.indexOf(currentRow);
        this.currentSelected = currentRow;
        this.$emit("tableSelectionChange", this.currentSelected);
      }
    },
    selectAll() {
      this.$refs.multipleTable.toggleAllSelection();
    },
  },
};
</script>

<style lang="less" scoped>
@import (reference) '../../views/apps/weishop/application/inventory/erpRowActions.less';
.content-fit-table {
  min-width: 0;
  /deep/ .el-table .cell, /deep/ .base-table-cell-nowrap {
    white-space: nowrap;
    overflow: visible;
    text-overflow: clip;
    word-break: keep-all;
  }
  /deep/ .el-table .cell { width: auto; }
  /deep/ .el-table__body-wrapper { overflow-x: auto; }
}
/deep/.el-radio__label {
  display: none !important;
}
/deep/.el-table th{
  // background: #f6f7fb;
  background: #f9f9f9;
}
/* 列头保持单行，避免长列名被拆成上下两行；显式宽度由业务表格自行控制 */
/deep/ .el-table th .cell {
  white-space: nowrap;
  word-break: keep-all;
}
/deep/.el-table-column--selection .cell{
  padding-left: 20px;
}
/deep/ .base-table-sequence-column .cell {
  white-space: nowrap;
}
/deep/ .base-table-sequence-column .base-table-cell-nowrap {
  overflow: visible;
  text-overflow: clip;
}
.base-table-cell-nowrap {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
/deep/ .base-table-column-nowrap .cell {
  overflow: visible !important;
  text-overflow: clip !important;
  white-space: nowrap;
  word-break: keep-all;
}
.inventory-row-actions {
  display: inline-flex;
  align-items: center;
  white-space: nowrap;
  .erp-row-action-spacing();
}
.inventory-table-theme {
  /deep/ .el-table__body td,
  /deep/ .el-table__body td .cell {
    color: #000;
  }
}
/deep/ .el-table td{
  border-bottom: 1px solid #f9f9f9;
}
/deep/.el-table th{
  border-bottom: 1px solid #f9f9f9;
}
/deep/ .el-table::before,
/deep/ .el-table__fixed::before,
/deep/ .el-table__fixed-right::before {
  background: #f9f9f9;
}
</style>
